module.exports = __webpack_public_path__ + "assets/0170bd0ae3f843029d4360d829f1ecaa.png";